export default __webpack_public_path__ + "static/media/patient-icon.8f4fb6c2.svg";